import { node } from "prop-types";

import styled from "styled-components";
import { borderRadius, padding, themeVariants } from "theme";

const SMotionDiv = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${({
    theme: {
      colors: { fnYellowNotice },
    },
  }) => fnYellowNotice};
  ${padding}
  ${borderRadius}
border: 1px solid ${({
    theme: {
      colors: { textWarning },
    },
  }) => textWarning};
`;

const FnrWarningBox = ({ children, ...rest }) => (
  <SMotionDiv $variant={themeVariants.container} $contentEmphasized {...rest}>
    {children}
  </SMotionDiv>
);

FnrWarningBox.propTypes = { children: node };

export default FnrWarningBox;
